import React from 'react';

const withHOCs =
  (...hocs) =>
  Component =>
  props =>
    hocs.reverse().reduce((children, HOC) => <HOC>{children}</HOC>, <Component {...props} />);

export default withHOCs;
